import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-efbdbf52"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-anchor-link", "href"]
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  key: 0,
  class: "cm-anchor__risk-badge"
}
const _hoisted_4 = {
  key: 0,
  class: "cm-anchor__children"
}

import { PropType } from 'vue'
import type { AnchorItem } from './types'


export default /*#__PURE__*/_defineComponent({
  ...{ name: 'AnchorLink' },
  __name: 'anchor-link',
  props: {
  item: {
    type: Object as PropType<AnchorItem>,
    required: true
  },
  activeHref: {
    type: String,
    required: true
  },
  indent: {
    type: Number,
    default: 0
  },
  useHash: {
    type: Boolean,
    default: false
  }
},
  emits: ["select"],
  setup(__props, { emit: __emit }) {



const props = __props

const emit = __emit

const handleClick = () => {
  emit('select', props.item)
}

return (_ctx: any,_cache: any) => {
  const _component_AnchorLink = _resolveComponent("AnchorLink", true)!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['cm-anchor__item', { 'is-active': __props.activeHref === __props.item.href }])
  }, [
    _createElementVNode("a", {
      class: "cm-anchor__link",
      "data-anchor-link": __props.item.href,
      href: __props.useHash ? __props.item.href : undefined,
      style: _normalizeStyle({ paddingLeft: `${__props.indent * 16 + 12}px` }),
      onClick: _withModifiers(handleClick, ["prevent"])
    }, [
      _renderSlot(_ctx.$slots, "item", {
        item: __props.item,
        active: __props.activeHref === __props.item.href,
        indent: __props.indent
      }, () => [
        _createElementVNode("span", {
          class: "cm-anchor__title",
          title: __props.item.title
        }, [
          _renderSlot(_ctx.$slots, "title", {
            item: __props.item,
            active: __props.activeHref === __props.item.href,
            indent: __props.indent
          }, () => [
            _createTextVNode(_toDisplayString(__props.item.title), 1)
          ]),
          (__props.item.riskCount && __props.item.riskCount > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.item.riskCount), 1))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2)
      ])
    ], 12, _hoisted_1),
    (__props.item.children?.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.children, (child) => {
            return (_openBlock(), _createBlock(_component_AnchorLink, {
              key: child.href,
              item: child,
              "active-href": __props.activeHref,
              indent: __props.indent + 1,
              "use-hash": __props.useHash,
              onSelect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('select', $event)))
            }, {
              item: _withCtx((slotProps) => [
                _renderSlot(_ctx.$slots, "item", _mergeProps({ ref_for: true }, slotProps))
              ]),
              title: _withCtx((slotProps) => [
                _renderSlot(_ctx.$slots, "title", _mergeProps({ ref_for: true }, slotProps))
              ]),
              _: 2
            }, 1032, ["item", "active-href", "indent", "use-hash"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})